// extracted by mini-css-extract-plugin
export default {"root":"BGFnl","content":"X0WyS","message":"Ixk6z"};